import * as React from "react";
import {Box, Button, Icon, Link, Select, SpaceBetween, Spinner, Table} from "@amzn/awsui-components-react";
import {TestCase, UATProject, UATStatus} from "../../types/UATProject";
import {useState} from "react";
import {TestCaseSummaryModal} from "./TestRunViewModal";
import {AxiosResponse} from "axios";
import {DownloadS3FileApiFactory, DownloadS3FileResponse} from "../../lusca-search-api/generated-src";
import {useMutation} from "@tanstack/react-query";

interface TestRunsViewProps {
    project: UATProject
}

export default function TestRunsView( { project } : TestRunsViewProps) {
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedTestCase, setSelectedTestCase] = useState<TestCase | null>(null);
  const downloadS3FileApi = DownloadS3FileApiFactory();

    const {mutate, isLoading, error} = useMutation<
        DownloadS3FileResponse,
        Error,
        { key: string }
    >(
        async ({key}) => {
            const response: AxiosResponse<DownloadS3FileResponse> = await downloadS3FileApi.download(key);
            console.log(response.data);
            return response.data;
        },
        {
            onSuccess: (data) => {
                window.location.href = data.url; // download file
            },
            onError: (err) => {
                console.error('Error:', err);
            },
        }
    );



    const statusOptions = Object.entries(UATStatus)
        .filter(([key]) => isNaN(Number(key)))
        .map(([key]) => ({
            label: key,
            value: UATStatus[key as keyof typeof UATStatus].toString()
        }));

    return (
        <>
        <Table
            renderAriaLive={({
                                 firstIndex,
                                 lastIndex,
                                 totalItemsCount
                             }) =>
                `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
            }
            columnDefinitions={[
                {
                    id: "name",
                    header: "Name",
                    cell: testCase => testCase.name,
                    sortingField: "name",
                    isRowHeader: true
                },
                {
                    id: "runCount",
                    header: "# of Runs",
                    cell: testCase => testCase.history.length,
                    sortingField: "runCount",
                    isRowHeader: true
                },
                {
                    id: "orderIDs",
                    header: "Order IDs",
                    cell: testCase => (
                        <Link
                            href="#"
                            onFollow={e => {
                                e.preventDefault();
                                const baseUrl = window.location.href.split('4443/')[0] + '4443/';
                                //window.location.href = `${baseUrl}${testCase.order.id}`;
                                // Or if you want to open in new tab:
                                window.open(`${baseUrl}?stage=${testCase.order.stage}&transactionId=${testCase.order.id}`, '_blank');
                            }}
                        >
                            {testCase.order.id}
                        </Link>
                    ),
                    sortingField: "runCount",
                    isRowHeader: true
                },
                {
                    id: "comment",
                    header: "Comment",
                    cell: testCase =>
                        testCase.history[testCase.history.length - 1]
                            ?.comments?.[testCase.history[testCase.history.length - 1].comments.length - 1]
                            ?.comment ?? "-",
                    sortingField: "comment"
                },
                {
                    id: "status",
                    header: "Status",
                    cell: testCase => (
                        <div
                            onClick={e => e.stopPropagation()}
                            onMouseDown={e => e.stopPropagation()}
                            style={{position: 'relative', zIndex: 1000}}
                        >
                            <Select
                                selectedOption={{
                                    label: testCase.status.toString(),
                                    value: testCase.status.toString()
                                }}
                                onChange={({detail}) => {
                                    if (detail.selectedOption.value) {
                                        testCase.status = detail.selectedOption.value as unknown as UATStatus;
                                    }
                                }}
                                options={statusOptions}
                                placeholder="Select status"
                                expandToViewport={true}
                            />
                        </div>
                    ),
                    sortingField: "status"
                },
              {
                id: "runTest",
                header: "Run Test",
                cell: testCase => {
                  const [isLoading, setIsLoading] = useState(false);

                  const handleRunTest = async () => {
                    setIsLoading(true);
                    setTimeout(() => {
                      setIsLoading(false);
                    }, 2000);
                  };

                  return (
                      <div style={{zIndex: 500}}>
                        <Button
                            onClick={handleRunTest}
                            disabled={isLoading}
                            ariaLabel="Run test"

                        >
                          {isLoading ? (
                              <Spinner size="normal"/>
                          ) : (
                              <>
                                <Icon name="caret-right-filled" variant="success" size={"normal"}/>
                                <span>Run</span>
                              </>
                          )}
                        </Button>
                      </div>
                  );
                },
                sortingField: "runTest"
              },
              {
                                id: "downloadFile",
                                header: "Download File",
                                cell: testCase => {
                                  const [isLoading, setIsLoading] = useState(false);

                                  const handleDownloadfile = async () => {
                                    mutate({key: 'uat-summary-report.csv'});
                                  };

                                  return (
                                      <div style={{zIndex: 1000}}>
                                        <Button
                                            onClick={handleDownloadfile}
                                            disabled={isLoading}
                                            ariaLabel="Download Result"

                                        >
                                          {isLoading ? (
                                              <Spinner size="normal"/>
                                          ) : (
                                              <>
                                                <Icon name="download" size={"normal"}/>
                                                <span>Result</span>
                                              </>
                                          )}
                                        </Button>
                                      </div>
                                  );
                                },
                                sortingField: "donwloadFile"
                              }

                            ]}
                            items={project.testCases}
                            loadingText="Loading resources"
                            resizableColumns
                            empty={
                              <Box
                                  margin={{vertical: "xs"}}
                                  textAlign="center"
                                  color="inherit"
                              >
                                <SpaceBetween size="m">
                                  <b>No resources</b>
                                  <Button>Create resource</Button>
                                </SpaceBetween>
                              </Box>
                            }
                        />
                        <TestCaseSummaryModal
                            visible={isModalVisible}
                            onDismiss={() => {
                              setModalVisible(false);
                              setSelectedTestCase(null);
                            }}
                            testCase={selectedTestCase}
                        />
                      </>
                  );
                }
